import script from "./images-select-multiple.vue?vue&type=script&setup=true&lang=js"
export * from "./images-select-multiple.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__